// extracted by mini-css-extract-plugin
export default {"root":"AssessmentChecksDetails_root__IXWSB"};